import { ResolveAlertType } from "./types";
import { AppStateModalFeedback } from ".";
import { ALERTS } from "../alerts/types";

const initialState: AppStateModalFeedback = {
  isLoading: false,
  isSuccessfulResolve: undefined,
  isGetFeedbackSuccessful: undefined,
  status: undefined,
  generated: undefined,
  lastUpdate: undefined,
  priority: undefined,
  feedback: undefined,
};
const reducer = (
  state = initialState,
  action: ResolveAlertType
): AppStateModalFeedback => {
  switch (action.type) {
    case ALERTS.SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_REQUEST:
      return { ...state, isLoading: true, isSuccessfulResolve: undefined };

    case ALERTS.SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_SUCSSESS:
      return { ...state, isLoading: false, isSuccessfulResolve: true };

    case ALERTS.SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_FAILURE:
      return { ...state, isLoading: false, isSuccessfulResolve: false };

    case ALERTS.GET_FEEDBACK_BY_ALERT_TYPE_AND_RESIDENT_ID_REQUEST:
      return {
        ...initialState,
        isLoading: true,
        isGetFeedbackSuccessful: undefined,
        isSuccessfulResolve: undefined,
      };

    case ALERTS.GET_FEEDBACK_BY_ALERT_TYPE_AND_RESIDENT_ID_SUCSSESS: {
      const data = action.payload;
      return {
        ...state,
        ...data,
        isLoading: false,
        isGetFeedbackSuccessful: true,
      };
    }

    case ALERTS.GET_FEEDBACK_BY_ALERT_TYPE_AND_RESIDENT_ID_FAILURE:
      return {
        ...initialState,
        isLoading: false,
        isGetFeedbackSuccessful: false,
      };
    default:
      return state;
  }
};

export default reducer;
